"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormField = void 0;
const useFormField_1 = require("@reactionable/core/lib/form/useFormField");
const FormField_1 = require("./FormField");
function useFormField(props) {
    return useFormField_1.useFormField(Object.assign({ Component: FormField_1.FormField }, props));
}
exports.useFormField = useFormField;
//# sourceMappingURL=useFormField.js.map